import { LOGGED_IN, SET_AUTH_TOKEN, MENU_OPEN } from './action-types';

export const set_logged_in = (payload) => {
  return {
    type: LOGGED_IN,
    payload
  };
};

export const set_auth_token = (payload) => {
  return {
    type: SET_AUTH_TOKEN,
    payload
  };
};

export const set_menu_open = (payload) => {
  return {
    type: MENU_OPEN,
    id: payload
  };
};
